import { ProtocolConfig } from "@silo/types";
import { satisfies } from "effect/Function";

export const anvil = satisfies<ProtocolConfig>()({
  firstBridgeSymbol: "ETH",
  secondBridgeSymbol: "XAI",
  marketWhitelist: new Set([
    // MARKET_ADDRESS.anvil.ETH_cbETH,
    // MARKET_ADDRESS.anvil.ETH_stETH,
    // MARKET_ADDRESS.anvil.FRAX_USDC,
    // MARKET_ADDRESS.anvil.LUSD_3CRV,
    // MARKET_ADDRESS.anvil.USDC,
  ]),
  pinnedMarkets: [],
  markets: {},
  nativeRewards: null,
} as const);
